import { render } from "./SharedMap.vue?vue&type=template&id=00cddf79&ts=true"
import script from "./SharedMap.vue?vue&type=script&lang=ts"
export * from "./SharedMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__